
import React, { act, useEffect, useMemo, useState } from 'react';
import { ErrorBoundary } from "react-error-boundary";
import { useApiData } from '../../contexts/apiService';
import { incidentsDefinitionItem, ProducerDefinitionItem } from '../../contexts/tableDefinitions';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, doc, getDoc, collection, getDocs } from 'firebase/firestore';
import Dropdown, { DropdownOption } from '../../components/common/dropdown/dropdown';
import { convertDateTimeForm, getCurrentDateTimeLocal, isArrayEmpty } from './helperfunctions';



interface CarrierContact {
    name: string;
    id: string;
}

interface userItem {
    name: string;
    id: string;
    company: string;
    email: string;
}

interface ProducerContact {
    name: string;
    id: string;
}

interface IncidentClassification {
    description: string;
    id: string;
    auditPoints: string;
}

interface dropdownItem {
    data: unknown[];
}

interface IncidentRowData {
    [key: string]: any;
}

interface PoliciesProps {
    hasAdminAccess: boolean;
    activeUser: string;
}
const Investigations: React.FC<PoliciesProps> = ({ activeUser, hasAdminAccess }) => {
    const { apiData, isLoading, handleAddRow, handleDeleteRow, handleEditOrder } = useApiData();
    const [carrierFilters, setCarrierFilters] = useState<CarrierContact | []>([]);
    const [allRockbridgeUsers, setAllRockbridgeUsers] = useState<userItem[]>([]);

    const carrierDataRef = React.useRef<any[]>([]);
    const carrierData = useMemo(() => {
        const value = apiData?.carrier_definition || [];
        carrierDataRef.current = value;
        return value;
    }, [apiData]);

    const auditDataRef = React.useRef<any[]>([]);
    const auditData = useMemo(() => {
        const value = apiData?.audit_table || [];
        auditDataRef.current = value;
        return value;
    }, [apiData]);

    const incidentsDataRef = React.useRef<any[]>([]);
    const incidentsData = useMemo(() => {
        if (true) {
            const value = apiData?.incidents_table || [];
            incidentsDataRef.current = value;
            return value;
        }
        return incidentsDataRef.current;
    }, [apiData]);

    const incidentsDefinitionRef = React.useRef<any[]>([]);
    const incidentsDefinition = useMemo(() => {
        if (true) {
            const value = apiData?.incidents_definition || [];
            incidentsDefinitionRef.current = value;
            return value;
        }
        return incidentsDefinitionRef.current;
    }, [apiData]);

    const producerDataRef = React.useRef<any[]>([]);
    const producerData = useMemo(() => {
        if (true) {
            const value = apiData?.producer_definition || [];
            producerDataRef.current = value;
            return value;
        }
        return producerDataRef.current;
    }, [apiData]);

    useEffect(() => {
        async function fetchRockbridgeUsers() {
            const db = getFirestore();
            const usersCollection = collection(db, "users");
            const snapshot = await getDocs(usersCollection);
            const usersList = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }) as userItem);
            const rockbridgeUsers = usersList.filter(
                user => user.company && user.company.toLowerCase() === "rockbridge"
            );
            const mappedRockbridgeUsers = rockbridgeUsers.map(user => ({
                email: user.email,
                name: user.name,
                id: user.id
            }) as userItem);
            setAllRockbridgeUsers(mappedRockbridgeUsers);
        }
        fetchRockbridgeUsers();
    }, []);
        /**
         * Generates an array of dropdown options from the provided carrier data.
         *
         * @param data - The carrier data object containing a `data` property, which is an array of carrier items.
         * Each carrier item should have `id` and `name` properties.
         * @returns An array of `DropdownOption` objects with `value` and `label` properties.
         */



    const InternalDropdown = (data: dropdownItem) => {
        let options: DropdownOption[] = [];
        if (!data) return options;
        for (const item of data.data as userItem[]) {
            options.push({
                value: item.email,
                label: item.name
            });
        }
        options.sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));
        return options;
    };



    const CarriersDropdown = (data: dropdownItem) => {
        let options: DropdownOption[] = [];
        if (!data) return options;
        for (const item of data.data as userItem[]) {
            options.push({
                value: item.id,
                label: item.name
            });
        }
        options.sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));
        return options;
    };

    const ProducersDropdown = (data: dropdownItem) => {
        let options: DropdownOption[] = [];
        if (!data) return options;
        let alreadyEntered = false;
        for (const item of data.data as ProducerDefinitionItem[]) {
            alreadyEntered = options.some(option => option.label === item.producer_name);
            if (!alreadyEntered) {
                options.push({
                    value: String(item.id),
                    label: item.producer_name
                });
            }
        }
        options.sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));
        return options;
    };

    const IncidentsDefinitionDropdown = (data: dropdownItem) => {
        let options: DropdownOption[] = [];
        if (!data) return options;
        let alreadyEntered = false;
        for (const item of data.data as incidentsDefinitionItem[]) {
            alreadyEntered = options.some(option => option.label === item.producer);
            if (!alreadyEntered) {
                options.push({
                    value: item.incidentsClassification,
                    label: item.description
                });
            }
        }
        options.sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));
        return options;
    };
        /**
         * Handles the selection of a new carrier from a dropdown component.
         * Finds the carrier in `carrierData` matching the provided `selectedOption` ID,
         * constructs a `CarrierContact` object, and updates the carrier filters state.
         *
         * @param selectedOption - The ID of the selected carrier option.
         */
        const [investigationModalShow, setInvestigationModalShow] = useState<boolean>(false);
        
        
       

    function EmailList({ users }: { users: any[] }) {
        if (users) {
            return (
                <>
                    {users.map((user, idx) => (
                        <div key={idx}>{typeof user === 'string' ? user : user.email || JSON.stringify(user)}</div>
                    ))}
                </>
            );
        }
    }
        // Delete handler for investigation entries
        async function handleDelete(investigationNumber: string | number) {
            // TODO: Implement actual delete logic (API call, state update, etc.)
            if (!investigationNumber) {
                alert('No investigationNumber provided.');
                return;
            }
            // Example: Confirm and reload
            if (window.confirm(`Are you sure you want to delete audit #${investigationNumber}?`)) {
                // Implement actual delete logic here
                alert(`Audit #${investigationNumber} scheduled for deletion.`);
                await handleDeleteRow(new Set([String(investigationNumber)]), "incidents");
                window.location.reload();
            }
        }

        function RowDetailsModal({ rowData, onClose }: { rowData: IncidentRowData; onClose: () => void }) {
            const [editMode, setEditMode] = useState<boolean>(false);
            const [inProgress, setInProgress] = useState<boolean>(false);

            const getDisplayValue = (key: string, value: any) => {
                if (value === null || value === undefined) return 'N/A';
                
                switch (key) {
                    case 'occuranceDate':
                        return new Date(value).toLocaleDateString('en-US');
                    case 'carrierID':
                        const carrier = carrierData.find((item) => String(item.id) === String(value));
                        return carrier ? carrier.name : 'N/A';
                    case 'incidentClassification':
                        const classification = incidentsDefinition.find((item) => String(item.incidentsClassification) === String(value));
                        return classification ? classification.description : 'N/A';
                    case 'auditPoints':
                        return value >= 0 ? value : 'N/A';
                    case 'driverID':
                        return `Firebase Placeholder: ${value}`;
                    default:
                        return String(value);
                }
            };
            const newIncidentClassificationSelected = (selectedOption:number) => {
                var filteredData = producerData;
                
                if(selectedOption >=0){
                    try{
                        var temp = incidentsDefinition.find((item) => Number(item.incidentsClassification) == selectedOption);
                        let selectedIncidentClassification: IncidentClassification ;
                        selectedIncidentClassification = temp ? { description: temp.description, id: String(temp.incidentsClassification), auditPoints:temp.standardPointValue } : { description: '', id: '',  auditPoints:''};
                        //console.log(selectedIncidentClassification);
                        setIncidentClassificationSelection(selectedIncidentClassification ? selectedIncidentClassification : null);
                    }catch(error){
                        console.error(error);
                    }
                    //check if environmental options were selected (may need to do additional check later on)
                }else{
                    setIncidentClassificationSelection(null);
                }
            };
            const [form, setForm] = useState({
                occuranceDate: convertDateTimeForm(rowData.occuranceDate),
                expirationDate: convertDateTimeForm(rowData.expiration),
                name: rowData.name,
                auditPoints: rowData.auditPoints,
                remedialActions: rowData.remedialActions,
                summary: rowData.incidentSummary,
                spills: 'Spill Volume: \nSpill Material: \nDispatched Cleaner Name: \n'
            });
            // Prepopulate selections based on rowData
            const [carrierSelection, setCarrierSelection] = useState<CarrierContact | null>(
                rowData.carrierID
                    ? (() => {
                        const carrier = carrierData.find((item) => String(item.id) === String(rowData.carrierID));
                        return carrier ? { name: carrier.name, id: String(carrier.id) } : null;
                    })()
                    : null
            );
            const [ProducerSelected, setProducerSelection] = useState<ProducerContact | null>(
                rowData.producerID
                    ? (() => {
                        // Try to find producer by name in producerData
                        const producer = producerData.find((item) => String(item.id) === String(rowData.producerID));
                        return producer ? { name: producer.producer_name, id: String(producer.id) } : null;
                    })()
                    : null
            );
            const [IncidentClassificationSelected, setIncidentClassificationSelection] = useState<IncidentClassification | null>(
                rowData.incidentClassification
                    ? (() => {
                        const classification = incidentsDefinition.find(
                            (item) => String(item.incidentsClassification) === String(rowData.incidentClassification)
                        );
                        return classification
                            ? {
                                description: classification.description,
                                id: String(classification.incidentsClassification),
                                auditPoints: classification.standardPointValue
                            }
                            : null;
                    })()
                    : null
            );
            
            const record = useMemo(() => {
                return {
                    occuranceDate: form.occuranceDate,
                    carrierID: carrierSelection?.id || "",
                    driverID: "-1",
                    incidentSummary: form.summary,
                    remedialActions: form.remedialActions, 
                    auditPoints: form.auditPoints,
                    incidentClassification: IncidentClassificationSelected?.id || "",
                    expiration: form.expirationDate,
                    producerID: ProducerSelected?.id || "",
                };
            }, [form, carrierSelection, IncidentClassificationSelected, ProducerSelected]); 
            
            const newCarrierSelected = (selectedOption:number) => {
                if(selectedOption >=0){
                    const temp = carrierData.find((item) => item.id == selectedOption);
                    let selectedCarrier: CarrierContact ;
                    selectedCarrier = temp ? { name: temp.name, id: String(temp.id) } : { name: '', id: '' };
                    setCarrierSelection(selectedCarrier ? selectedCarrier : null);
                }else{
                    setCarrierSelection(null);
                }
            };
            
            const newProducerSelected = (selectedOption:number) => {
                var filteredData = ProducersDropdown({ data: producerData });
                if(selectedOption >=0){
                    var temp = null;
                    var selectedProducer: CarrierContact;
                    try{
                        temp = filteredData.find((item) => Number(item.value) == selectedOption);
                        selectedProducer = temp ? { name: temp.label, id: String(temp.value) } : { name: '', id: '' };
                        setProducerSelection(selectedProducer ? selectedProducer : null);
                    }catch(error){
                        console.error(error);
                    }
                }else{
                    setProducerSelection(null);
                }
            };
            const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {

                const { name, value } = e.target;
                setForm(prev => ({ ...prev, [name]: value }));
            };
            
            useEffect(() => {
                const hasInput = Object.values(form).some(val => val && val.trim() !== '');
                const dropdown = (!!ProducerSelected && Object.keys(ProducerSelected).length > 0)
                    ||(!!carrierSelection && Object.keys(carrierSelection).length > 0)
                    ||(!!IncidentClassificationSelected && Object.keys(IncidentClassificationSelected).length > 0);
                //console.log(dropdown);
                setInProgress(hasInput||dropdown);
            }, [form,ProducerSelected,carrierSelection]);
            
            const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
                //institute form verification here in the future, for now just makes sure that Name, email, and position are included, phone not required
                e.preventDefault();
                if(form.occuranceDate && form.summary){
                    
    

                    var summary= form.summary;
                    const newRecord = {
                        occuranceDate: form.occuranceDate,
                        carrierID: carrierSelection?.id || "",
                        driverID: "-1",
                        incidentSummary: summary,
                        remedialActions: form.remedialActions, 
                        producerID: ProducerSelected?.id || "",
                        auditPoints: form.auditPoints,
                        incidentClassification: IncidentClassificationSelected?.id || "",
                        expiration: form.expirationDate
                    };
                    await Promise.all(Object.entries(newRecord).map(async ([key, newValue]) => {
                        const oldValue = (record as any)[key];
                        if (oldValue !== newValue) {
                            //editorder here
                            await handleEditOrder("incidents",rowData.incidentNumber, key,oldValue, newValue);
                        }
                    }));
                    
                    
                    alert("Form submitted successfully!");
                    try{
                        //await;
                    }catch(error){
                        console.error(error);
                    }
                    window.location.reload();
                    //handleNewUser(formData.name, formData.email, formData.position, formData.phone);
                    // Reset form (optional)
                } else{
                    console.error("All fields are required");
                }
            };
            const isArrayEmpty = (array_1: CarrierContact|null)=> {
                return array_1 ? Object.keys(array_1).length : 0;
            };
            const getDisplayLabel = (key: string) => {
                return formatHeader(key);
            };

            return (
                <div className='carrier-modal-overlay' onClick={onClose}>
                    {!editMode ? 
                        <div className='carrier-modal-content' onClick={e => e.stopPropagation()}>
                            <div className='carrier-modal-header'>
                                <h2>Incident Details</h2>
                                <button onClick={onClose} className="carrier-modal-close-btn">
                                    <span className="carrier-close">&times;</span>
                                </button>
                            </div>
                            
                            <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                                {Object.entries(rowData).map(([key, value]) => (
                                    <div key={key} className="incident-details-item">
                                        <strong className="incident-details-label">
                                            {getDisplayLabel(key)}:
                                        </strong>
                                        <div
                                            className={
                                            "incident-details-value" +
                                            ((key === 'incidentSummary' || key === 'remedialActions') ? " prewrap" : "")
                                            }
                                        >
                                            {getDisplayValue(key, value)}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            
                            <div className="incident-details-footer">
                                <button onClick={onClose} className="carrier-modal-submit-btn">
                                    Close
                                </button>
                                <button onClick={()=>setEditMode(true)} className="carrier-modal-submit-btn edit">
                                    Edit
                                </button>
                                <button
                                    style={{ marginLeft: '10px', backgroundColor: '#e74c3c', color: '#fff' }}
                                    className="carrier-modal-submit-btn"
                                    onClick={() => handleDelete(rowData.incidentNumber)}
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    :
                        <div className='carrier-modal-content' onClick={e => e.stopPropagation()}>
                            <div className='carrier-modal-header'>
                                <h2>Edit Incident Entry</h2>
                            </div>        
                            <form className="carrier-modal-form" onSubmit={(e) => {handleSubmit(e)}} >
                            <div>
                                <label className="carrier-modal-form-label" htmlFor="occuranceDate">Incident Date: </label>
                                <input
                                type="datetime-local"
                                className={`carrier-modal-form-input${form.occuranceDate !== record.occuranceDate ? ' field-changed' : ''}`}
                                id="occuranceDate"
                                name="occuranceDate"
                                value={form.occuranceDate}
                                max={getCurrentDateTimeLocal()}
                                onChange={handleChange}
                                required
                                />
                            </div>
                            <div>
                                <label className="carrier-modal-form-label" htmlFor="expirationDate">Expiration Date: </label>
                                <input
                                type="datetime-local"
                                className={`carrier-modal-form-input ${form.expirationDate !== record.expiration ? ' field-changed' : ''}`}
                                id="expirationDate"
                                name="expirationDate"
                                value={form.expirationDate}
                                onChange={handleChange}
                                required
                                />
                            </div>      
                            <div className={`${carrierSelection?.id !== record.carrierID ? ' field-changed' : ''}`}>
                                <label className="carrier-modal-form-label" htmlFor="location">Carrier: </label>
                                <Dropdown
                                    options={CarriersDropdown({ data: carrierData })}
                                    placeholder={carrierSelection? carrierSelection.name: "Select Carrier"}
                                    onChange={(value) => {
                                        newCarrierSelected(Number(value));
                                    }}
                                />
                                {isArrayEmpty(carrierSelection)?(
                                    <>
                                        CarrierID: {carrierSelection?.id}
                                    </> 
                                ):""}  
                                    
                            </div>
                            <div>
                                <label className="carrier-modal-form-label" htmlFor="Driver">Driver: </label>
                                To be implemented
                            </div>
                            <div className={`${ProducerSelected?.id !== record.producerID ? ' field-changed' : ''}`}>
                                <label className="carrier-modal-form-label" htmlFor="Producer">Producer: </label>
                                <Dropdown
                                    options={ProducersDropdown({ data: producerData })}
                                    placeholder={ProducerSelected? ProducerSelected.name : "Select Producer"}
                                    onChange={(value) => {
                                        newProducerSelected(Number(value));
                                    }}
                                />
                            </div>
                            <div className={`${IncidentClassificationSelected?.id !== record.incidentClassification ? ' field-changed' : ''}`}>
                                <label className="carrier-modal-form-label" htmlFor="classification">
                                    Incident Classification: 
                                </label>
                                <Dropdown
                                    options={IncidentsDefinitionDropdown({ data: incidentsDefinition })}
                                    placeholder={IncidentClassificationSelected ? IncidentClassificationSelected.description : "Select Classification"}
                                    onChange={(value) => {
                                        try{
                                            newIncidentClassificationSelected(Number(value));
                                        }catch(error){
                                            console.error(error);
                                        }
                                        
                                    }}
                                />
                            </div>
                            <div>
                                <label className="carrier-modal-form-label" htmlFor="auditPoints">
                                    Audit Points: 
                                </label>
                                <input
                                className={`carrier-modal-form-input ${form.auditPoints !== record.auditPoints ? ' field-changed' : ''}`}
                                id='auditPoints'
                                name='auditPoints'
                                type='number'
                                value={form.auditPoints}
                                onChange={handleChange}
                                placeholder = '0'
                                />
                            </div>
                            <div>
                                <label className="carrier-modal-form-label" htmlFor="summary">
                                    Investigation Summary: 
                                </label>
                                <textarea
                                className={`carrier-modal-form-input ${form.summary !== record.incidentSummary ? ' field-changed' : ''}`}
                                id="summary"
                                name="summary"
                                value={form.summary}
                                onChange={handleChange}
                                placeholder = "Enter all remaining known details here per QMS standard"
                                required
                                />
                            </div>
            
                            <div>
                                <label className="carrier-modal-form-label" htmlFor="actions">Remedial Actions: </label>
                                <textarea
                                className={`carrier-modal-form-input ${form.remedialActions !== record.remedialActions ? ' field-changed' : ''}`}
                                id="remedialActions"
                                name="remedialActions"
                                value={form.remedialActions}
                                onChange={handleChange}
                                
                                />
                            </div>
                            
                            <button className = "carrier-modal-submit-btn" type="submit">Submit Changes</button>
                        </form>
                        </div>
                    }
                </div>
            );
        }


        function InvestigationEntry(){
            const [inProgress, setInProgress] = useState<boolean>(false);
            const [form, setForm] = useState({
                date: '',
                name: activeUser,
                auditPoints: '',
                summary: '',
                remedialActions: '',
                actions: '',
                spills: 'Spill Volume: \nSpill Material: \nDispatched Cleaner Name: \n'
            });
            const [carrierSelection, setCarrierSelection] = useState<CarrierContact|null>(null);
            const [notifySelected, setNotifySelection] = useState<string[]>([]);
            const [ProducerSelected, setProducerSelection] = useState<ProducerContact|null>(null);
            const [IncidentClassificationSelected, setIncidentClassificationSelection] = useState<IncidentClassification|null>(null);
            const newNotifySelected = (selectedOption:string) => {
                
                if(notifySelected){
                    setNotifySelection(prev => [...prev, selectedOption]);
                }else{
                    var tempArray:string[]=[selectedOption];
                    setNotifySelection(tempArray);
                }
                
            };
            
            const newCarrierSelected = (selectedOption:number) => {
                if(selectedOption >=0){
                    const temp = carrierData.find((item) => item.id == selectedOption);
                    let selectedCarrier: CarrierContact ;
                    selectedCarrier = temp ? { name: temp.name, id: String(temp.id) } : { name: '', id: '' };
                    setCarrierSelection(selectedCarrier ? selectedCarrier : null);
                }else{
                    setCarrierSelection(null);
                }
            };
            const newProducerSelected = (selectedOption:number) => {
                var filteredData = ProducersDropdown({ data: producerData });
                if(selectedOption >=0){
                    var temp = null;
                    var selectedProducer: CarrierContact;
                    try{
                        temp = filteredData.find((item) => Number(item.value) == selectedOption);
                        selectedProducer = temp ? { name: temp.label, id: String(temp.value) } : { name: '', id: '' };
                        setProducerSelection(selectedProducer ? selectedProducer : null);
                    }catch(error){
                        console.error(error);
                    }
                }else{
                    setProducerSelection(null);
                }
            };

            const newIncidentClassificationSelected = (selectedOption:number) => {
                var filteredData = producerData;
                
                if(selectedOption >=0){
                    try{
                        var temp = incidentsDefinition.find((item) => Number(item.incidentsClassification) == selectedOption);
                        let selectedIncidentClassification: IncidentClassification ;
                        selectedIncidentClassification = temp ? { description: temp.description, id: String(temp.incidentsClassification), auditPoints:temp.standardPointValue } : { description: '', id: '',  auditPoints:''};
                        //console.log(selectedIncidentClassification);
                        setIncidentClassificationSelection(selectedIncidentClassification ? selectedIncidentClassification : null);
                    }catch(error){
                        console.error(error);
                    }
                    //check if environmental options were selected (may need to do additional check later on)
                    if(selectedOption == 10){
                        newNotifySelected("accounting@rockbridgepetroleum.com");
                        newNotifySelected("BDTeam@rockbridgepetroleum.com");
                    }else{
                        setNotifySelection([]);
                    }
                }else{
                    setProducerSelection(null);
                }
            };
            
            
            // Update form state on input change
            const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                const { name, value } = e.target;
                setForm(prev => ({ ...prev, [name]: value }));
            };


            // Watch for changes and set inProgress accordingly
            useEffect(() => {
                const hasInput = Object.values(form).some(val => val && val.trim() !== '');
                const dropdown = (!!ProducerSelected && Object.keys(ProducerSelected).length > 0)
                    ||(!!carrierSelection && Object.keys(carrierSelection).length > 0)
                    ||(!!notifySelected && Object.keys(notifySelected).length > 0)
                    ||(!!IncidentClassificationSelected && Object.keys(IncidentClassificationSelected).length > 0);
                //console.log(dropdown);
                setInProgress(hasInput||dropdown);
            }, [form,ProducerSelected,carrierSelection]);

            
            const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
                //institute form verification here in the future, for now just makes sure that Name, email, and position are included, phone not required
                e.preventDefault();
                if(form.date && form.summary && carrierSelection){
                    const fullsubmit: { key: string, value: any }[] = Object.entries(form).map(([key, value]) => ({ key, value }));
                    
                    fullsubmit.push({
                        key: "notify",
                        value: notifySelected ||[]
                    });
                    fullsubmit.push({
                        key: "carrier",
                        value: carrierSelection?.id ||-1
                    });
                    fullsubmit.push({
                        key: "producer",
                        value: ProducerSelected?.id ||-1
                    });
                    fullsubmit.push({
                        key: "classification",
                        value: IncidentClassificationSelected?.id ||-1
                    });
                    
                    
                    const dateObj = new Date(form.date);
                    dateObj.setFullYear(dateObj.getFullYear() + 1);
                    var expDate = dateObj.toISOString();
                    expDate = expDate.slice(0,expDate.length-5);
                    
                    var summary;
                    if(IncidentClassificationSelected && IncidentClassificationSelected.id == '12'){
                        summary = form.spills+"\n"+form.summary
                    }else{
                        summary = form.summary
                    }
                    const record = {
                        occuranceDate: form.date,
                        carrierID: carrierSelection?.id || "",
                        driverID: "-1",
                        incidentSummary: summary,
                        remedialActions: form.remedialActions, 
                        auditPoints: form.auditPoints,
                        incidentClassification: IncidentClassificationSelected?.id || "",
                        expiration: expDate,
                        producerID: ProducerSelected?.id||"",
                    };
                    alert("Form submitted successfully!");
                    try{
                        await handleAddRow("incidents", record);
                        window.location.reload();
                    }catch(error){
                        console.error(error);
                    }
                    //window.location.reload();
                    //handleNewUser(formData.name, formData.email, formData.position, formData.phone);
                    // Reset form (optional)
                } else{
                    console.error("All fields are required");
                }
            };


            function formReset(){
                setCarrierSelection(null);
                setProducerSelection(null);
                setIncidentClassificationSelection(null);
                setNotifySelection([]);
                setInvestigationModalShow(false); 
                setInProgress(false)
            }
            const isArrayEmpty = (array_1: CarrierContact|null)=> {
                return array_1 ? Object.keys(array_1).length : 0;
            };

            return(
                <div onClick={()=>{
                    if(!inProgress){
                        setInvestigationModalShow(false);
                    }else{
                        console.error("Form In Progress")
                    }
                }} className='carrier-modal-overlay'>
                    <div className='carrier-modal-content' onClick={e => e.stopPropagation()}>
                        Add Incident Report
                        <button onClick={()=>{formReset()}} className="carrier-modal-close-btn">
                            <span className="carrier-close">&times;</span>
                        </button>
                        <form className="carrier-modal-form" onSubmit={(e) => {handleSubmit(e)}} >
                            <div>
                                <label className="carrier-modal-form-label" htmlFor="date">Incident Date: </label>
                                <input
                                type="datetime-local"
                                className='carrier-modal-form-input'
                                id="name"
                                name="date"
                                value={form.date}
                                max={getCurrentDateTimeLocal()}
                                onChange={handleChange}
                                required
                                />
                            </div>   
                            <div>
                                <label className="carrier-modal-form-label" htmlFor="location">Carrier: </label>
                                <Dropdown
                                    options={CarriersDropdown({ data: carrierData })}
                                    placeholder={carrierSelection? carrierSelection.name: "Select Carrier"}
                                    onChange={(value) => {
                                        newCarrierSelected(Number(value));
                                    }}
                                />
                                {isArrayEmpty(carrierSelection)?(
                                    <>
                                        CarrierID: {carrierSelection?.id}
                                    </> 
                                ):""}  
                                    
                            </div>
                            <div>
                                <label className="carrier-modal-form-label" htmlFor="Driver">Driver: </label>
                                To be implemented
                            </div>
                            <div>
                                <label className="carrier-modal-form-label" htmlFor="Producer">Producer: </label>
                                <Dropdown
                                    options={ProducersDropdown({ data: producerData })}
                                    placeholder={ProducerSelected? ProducerSelected.name : "Select Producer"}
                                    onChange={(value) => {
                                        newProducerSelected(Number(value));
                                    }}
                                />
                                {isArrayEmpty(ProducerSelected)?(
                                    <>
                                        ProducerID: {ProducerSelected?.id}
                                    </> 
                                ):""}  
                            </div>
                            <div>
                                <label className="carrier-modal-form-label" htmlFor="classification">
                                    Incident Classification: 
                                </label>
                                <Dropdown
                                    options={IncidentsDefinitionDropdown({ data: incidentsDefinition })}
                                    placeholder={IncidentClassificationSelected ? IncidentClassificationSelected.description : "Select Classification"}
                                    onChange={(value) => {
                                        try{
                                            newIncidentClassificationSelected(Number(value));
                                        }catch(error){
                                            console.error(error);
                                        }
                                        
                                    }}
                                />
                            </div>
                            <div>
                                <label className="carrier-modal-form-label" htmlFor="auditPoints">
                                    Audit Points: 
                                </label>
                                <input
                                className='carrier-modal-form-input'
                                id='auditPoints'
                                name='auditPoints'
                                type='number'
                                value={form.auditPoints}
                                onChange={handleChange}
                                placeholder = '0'
                                />
                            </div>
                            <div>
                                <label className="carrier-modal-form-label" htmlFor="summary">
                                    Investigation Summary: 
                                </label>
                                <textarea
                                className='carrier-modal-form-input'
                                id="summary"
                                name="summary"
                                value={form.summary}
                                onChange={handleChange}
                                placeholder = "Enter all remaining known details here per QMS standard"
                                required
                                />
                            </div>
                            {IncidentClassificationSelected && IncidentClassificationSelected.id =='10' ? (
                                <div>
                                    <label className="carrier-modal-form-label" htmlFor="spills">Minimum Spill Details: </label>
                                    <textarea
                                    className='carrier-modal-form-input'
                                    id="spills"
                                    name="spills"
                                    value={form.spills}
                                    onChange={handleChange}
                                    required
                                    >   
                                    </textarea>
                                </div>
                            ):null}
                            <div>
                                <label className="carrier-modal-form-label" htmlFor="actions">Remedial Actions: </label>
                                <textarea
                                className='carrier-modal-form-input'
                                id="remedialActions"
                                name="remedialActions"
                                value={form.remedialActions}
                                onChange={handleChange}
                                
                                />
                            </div>
                            <div>
                                <label className="carrier-modal-form-label" htmlFor="Notify">Notify: </label>
                                <Dropdown
                                    options={InternalDropdown({ data:  allRockbridgeUsers })}
                                    placeholder={"Select Users"}
                                    onChange={(value) => {
                                        newNotifySelected(value);
                                    }
                                    }
                                />
                                <EmailList users={notifySelected} />
                            </div>
                            <button className = "carrier-modal-submit-btn" type="submit">Submit</button>
                        </form>
                    </div>
                </div>
            );
        }



        function formatHeader(key: string): string {
            switch (key) {
                case 'auditPoints':
                    return 'Audit Points';
                case 'carrierID':
                    return 'Carrier Name';
                case 'auditLocation':
                    return 'Audit Location';
                case 'driverID':
                    return 'Driver ID';
                case 'incidentClassification':
                    return 'Incident Type';
                case 'incidentSummary':
                    return 'Description';
                case 'occuranceDate':
                    return 'Occurrence Date';
                // Add more cases as needed for your keys
                default:
                    // Capitalize first letter and replace underscores with spaces as a fallback
                    return key.replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase());
            }
        }
        /**
         * 
         * This function filters the `auditData` array based on the selected carrier's ID,
         * if `carrierFilters` is provided and contains an `id` property. It logs the audit data
         * before filtering and the filtered result after applying the filter.
         *
         * @remarks
         * - If `carrierFilters` is not provided or does not contain an `id`, the original `auditData` is used.
         * - As the carrierFilers is set to an empty array by default, the function will not return null, so if the id
         * is not found, it will return the original `auditData`.
         * - The function is intended for debugging and inspection purposes.
         */
        function DisplayRowData() {
            const [selectedRowData, setSelectedRowData] = useState<IncidentRowData | null>(null);
            let resultArray: any[] = [];
            for(let i in incidentsData){
                let tempObj: any = {};
                let originalData: any = {...incidentsData[i]};
                for(let j in incidentsData[i]){
                    if(j === 'occuranceDate'){
                        tempObj[j] = new Date(incidentsData[i][j]).toLocaleDateString('en-US');
                    }else{
                        switch(j){
                            case 'carrierID':
                                const carrier = carrierData.find((item) => String(item.id) === String(incidentsData[i][j]));
                                tempObj[j] = carrier && carrier.name ? carrier.name : 'N/A'; // Handle empty
                                break;
                            case 'incidentSummary':
                            case 'incidentClassification':
                                const classification = incidentsDefinition.find((item) => String(item.incidentsClassification) === String(incidentsData[i][j]));
                                tempObj[j] = classification && classification.description ? classification.description : 'N/A'; // Handle empty
                                break;
                            case 'auditPoints':
                                tempObj[j] = incidentsData[i][j]>=0 ? incidentsData[i][j]:'N/A' ; // Handle empty
                                break;
                            case 'driverID':
                                tempObj[j] = 'Firebase Placeholder: '+ incidentsData[i][j]; // Handle empty
                                break;
                        }
                    }
                }
                tempObj._originalData = originalData;
                resultArray.push(tempObj);
            }
            if (resultArray.length === 0) {
                return <div className="no-data-message">No audit data available for the selected carrier.</div>;
            }
            const handleRowClick = (item: any) => {
                // Pass the original data to the modal
                setSelectedRowData(item._originalData);
            };

            const closeModal = () => {
                setSelectedRowData(null);
            };
            return(
                <>
                    {/* Only render modal when selectedRowData exists */}
                    {selectedRowData && (
                        <RowDetailsModal 
                            rowData={selectedRowData} 
                            onClose={closeModal} 
                        />
                    )}
                    <table className="audit-table">
                        <tbody>
                            <tr>
                                {resultArray.length > 0 &&
                                    Object.keys(resultArray[0])
                                        .filter(key => key !== '_originalData') // Don't show the original data column
                                        .map((key, idx) => (
                                            <th key={idx}>{formatHeader(key)}</th>
                                        ))
                                }
                            </tr>
                            {resultArray.map((item, idx) => (
                                <tr 
                                    key={item.incidentNumber || idx}
                                    onClick={() => handleRowClick(item)}
                                    style={{ cursor: 'pointer' }}
                                    className="clickable-row"
                                >
                                    {Object.entries(item)
                                        .filter(([key]) => key !== '_originalData') // Don't render the original data
                                        .map(([key, value], i) => (
                                            <td key={i}>{String(value)}</td>
                                        ))
                                    }
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
                
            );
        }

        return(
            <div className="audit-table-container">
                
                <ErrorBoundary fallback={<div>Error loading audit data.</div>}>
                </ErrorBoundary>
                 
                <>
                    <h1 className="audit-table-title">
                        Investigations
                    </h1>
                    { investigationModalShow ? (
                        <>
                            <InvestigationEntry />
                        </> 
                    ): null}
                    
                </>
                
                
                {isLoading? (
                    <div className="loading-spinner">
                        <div className="spinner"></div>
                    </div>
                ) : (
                    <div>
                        <button className='addAuditEntry' onClick={()=>{setInvestigationModalShow(!investigationModalShow)}}>
                        +
                        </button>
                        <DisplayRowData />
                    </div>
                )}
                

            </div>
        );
    }

export default Investigations;
